import type { ILaboratory } from "../components/util/Clases";

/**
 * Projekt Firebase z 2022 (test-reminder-427) nie istnieje, a oba klucze API sa niewazne,
 * wiec kolekcja "laboratories" nie ma skad sie wziac. Dane ponizej sa wpisane lokalnie
 * i pochodza ze stron samych placowek, sprawdzone 5.11.2026.
 * Cennika nie ma, bo go nie znam - lepiej brak liczby niz liczba zmyslona.
 */

export const rekomendowana: ILaboratory = {
  name: "Salve Medica",
  adress: {
    city: "Łódź",
    street: "ul. Szparagowa 10, bud. A",
    code: "91-211",
    geoHash: "",
  },
  street: "ul. Szparagowa 10, bud. A",
  hours: { from: "07:00", to: "20:00" },
  tel: "+48 42 254 64 59",
  tests: [],
};

export const placowki: ILaboratory[] = [rekomendowana];

/** Pobrania materialu do badan, osobne od godzin przychodni. Zrodlo: salve.pl */
export const godzinyPobran = {
  tydzien: "pon-pt 7:00-18:30",
  sobota: "sob 8:00-11:00 (komercyjnie)",
};

/**
 * Ogolnopolskie sieci laboratoriow. Nie wpisuje adresow pojedynczych punktow,
 * bo jest ich setki i nie zweryfikuje kazdego. Zamiast tego kieruje do wyszukiwarek
 * prowadzonych przez same sieci - tam dane sa aktualne z definicji.
 * Adresy wyszukiwarek sprawdzone 5.11.2026 (HTTP 200).
 */
export type Siec = {
  nazwa: string;
  opis: string;
  wyszukiwarka: string;
  www: string;
};

export const sieci: Siec[] = [
  {
    nazwa: "Diagnostyka",
    opis: "Największa sieć laboratoriów w Polsce, punkty pobrań w całym kraju.",
    wyszukiwarka: "https://diag.pl/placowki/",
    www: "https://diag.pl/",
  },
  {
    nazwa: "ALAB laboratoria",
    opis: "Blisko 800 punktów pobrań i kilkadziesiąt laboratoriów we wszystkich województwach.",
    wyszukiwarka: "https://www.alab.pl/punkty-pobran",
    www: "https://www.alab.pl/",
  },
  {
    nazwa: "Synevo",
    opis: "Ogólnopolska sieć laboratoriów, część grupy Medicover.",
    wyszukiwarka: "https://synevo.pl/punkty-pobran/",
    www: "https://synevo.pl/",
  },
];
